var map = {
	"./insaweb.default.DEVELOPMENT.config": 594,
	"./insaweb.default.PRODUCTION.config": 595
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;


//////////////////
// WEBPACK FOOTER
// . ^\.\/insaweb\.default\..*\.config$
// module id = 958
// module chunks = 3